module.exports = __webpack_public_path__ + "fe48a9724fbe2a0e447a04c2e9392ddc.png";